import { useCallback, useEffect, useState } from "react";
import { listTopics } from "../services/quizAdminService";

const normalizeTopicId = (topic) => {
  return topic?._id || topic?.id || topic?.topic_id || "";
};

const filterTopicsByAccess = (topics, allowedTopicIds) => {
  if (!Array.isArray(allowedTopicIds)) return topics;
  if (allowedTopicIds.length === 0) return [];
  const allowedSet = new Set(allowedTopicIds);
  return topics.filter((topic) => allowedSet.has(normalizeTopicId(topic)));
};

export const useQuizTopics = ({ headers, allowedTopicIds, enabled = true } = {}) => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState(null);

  const loadTopics = useCallback(async () => {
    if (!enabled) {
      setLoading(false);
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const response = await listTopics({ headers, all: true });
      const filtered = filterTopicsByAccess(response?.topics || [], allowedTopicIds);
      setTopics(filtered);
    } catch (err) {
      setError(err?.message || "Error cargando topicos");
      setTopics([]);
    } finally {
      setLoading(false);
    }
  }, [allowedTopicIds, enabled, headers]);

  useEffect(() => {
    loadTopics();
  }, [loadTopics]);

  return {
    topics,
    loading,
    error,
    reload: loadTopics,
  };
};
